import { render, staticRenderFns } from "./SalesFreightInformation.vue?vue&type=template&id=4eb583d5&scoped=true"
import script from "./SalesFreightInformation.vue?vue&type=script&lang=js"
export * from "./SalesFreightInformation.vue?vue&type=script&lang=js"
import style0 from "./SalesFreightInformation.vue?vue&type=style&index=0&id=4eb583d5&prod&scoped=true&lang=css"
import style1 from "./SalesFreightInformation.vue?vue&type=style&index=1&id=4eb583d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb583d5",
  null
  
)

export default component.exports